import update from 'immutability-helper'
import {
  ADD_MODULE,
  SET_ACTIVE_MODULE,
  REMOVE_CONFIG,
  DELETE_MODULE,
  RESET_BASE_PANES,
  SWITCH_CONFIG,
} from '../constants'
import MODULE_CONFIGS from '../../pages/Lego/editor/Configs/index'

const initState = {
  panes: [
    {
      title: '基础设置',
      content: MODULE_CONFIGS.BaseConfig,
      key: 'root',
      id: 'root',
      closable: false,
    },
  ],
  activeKey: 'root',
  activeId: '',
}

export function setPanes(state = initState, action: any) {
  switch (action.type) {
    case SET_ACTIVE_MODULE:
      return update(state, {
        activeKey: {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          $apply: activeKey => {
            const item = state.panes.find(item => item.id === action.id)
            if (item) {
              return item.key
            } else {
              return action.id
            }
          },
        },
        activeId: {
          $set: action.id,
        },
        panes: {
          $apply: panes => {
            const item = state.panes.find(item => item.id === action.id)
            if (!item) {
              panes.push({
                title: '组件设置:' + action.render,
                // config component
                content: MODULE_CONFIGS[action.render],
                id: action.id,
                key: action.id,
                pid: action.pid,
                closable: true,
              })
            }
            return panes
          },
        },
      })
    case SWITCH_CONFIG:
      return update(state, {
        activeKey: {
          $set: action.activeKey || 'root',
        },
        activeId: {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          $apply: activeId => {
            const activePane = state.panes.find(item => item.key === action.activeKey)
            return activePane ? activePane.id : ''
          },
        },
      })
    case ADD_MODULE:
      return update(state, {
        panes: {
          $apply: function (panes: Array<any>) {
            let node: any = null
            if (MODULE_CONFIGS[action.render]) {
              node = {
                title: action.render,
                // config component
                content: MODULE_CONFIGS[action.render],
                id: action.id,
                key: action.id,
                pid: action.pid,
                config: {},
              }
            }
            if (node) {
              panes.push(node)
            }
            return panes
          },
        },
        activeKey: {
          $set: action.id,
        },
        activeId: {
          $set: action.id,
        },
      })
    case REMOVE_CONFIG:
      return update(state, {
        activeKey: {
          $apply: () => {
            const index = state.panes.findIndex(item => item.key === action.key)
            if (index) {
              return state.panes[index - 1].key
            }
            return 'root'
          },
        },
        activeId: {
          $apply: () => {
            const index = state.panes.findIndex(item => item.key === action.key)
            if (index) {
              return state.panes[index - 1].id
            }
            return ''
          },
        },
        panes: {
          $apply: function (panes) {
            if (!action.key) {
              return panes
            }
            return panes.filter((panel: any) => {
              return panel.key !== action.key
            })
          },
        },
      })
    case DELETE_MODULE:
      const deleteIndex = state.panes.findIndex(item => item.id === action.id)
      return update(state, {
        activeKey: {
          $apply: activeKey => {
            if (state.panes[deleteIndex] && state.panes[deleteIndex].key === activeKey) {
              return state.panes[deleteIndex - 1].key
            }
            return activeKey
          },
        },
        activeId: {
          $apply: activeId => {
            if (state.panes[deleteIndex] && state.panes[deleteIndex].key === state.activeKey) {
              return state.panes[deleteIndex - 1].id
            }
            return activeId
          },
        },
        panes: {
          // 删除
          $apply: function (panes) {
            if (deleteIndex) {
              panes.splice(deleteIndex, 1)
            }
            return panes
          },
        },
      })
    case RESET_BASE_PANES:
      return update(state, {
        $set: {
          panes: [
            {
              title: '基础设置',
              content: MODULE_CONFIGS.BaseConfig,
              key: 'root',
              id: 'root',
              closable: false,
            },
          ],
          activeKey: 'root',
          activeId: '',
        },
      })
    default:
      return state
  }
}
